import plugin_vue3_A0OWXRrUgq from "/usr/src/nuxt-app/node_modules/@pinia/nuxt/dist/runtime/plugin.vue3.mjs";
import components_plugin_KR1HBZs4kY from "/usr/src/nuxt-app/.nuxt/components.plugin.mjs";
import vueuse_head_plugin_D7WGfuP1A0 from "/usr/src/nuxt-app/node_modules/nuxt/dist/head/runtime/lib/vueuse-head.plugin.mjs";
import router_Pg0DINazwm from "/usr/src/nuxt-app/node_modules/nuxt/dist/pages/runtime/plugins/router.mjs";
import prefetch_client_3cwHvxIDEX from "/usr/src/nuxt-app/node_modules/nuxt/dist/pages/runtime/plugins/prefetch.client.mjs";
import fontawesome_klhsrycjcK from "/usr/src/nuxt-app/plugins/fontawesome.js";
import i18n_sVHQBgnb3t from "/usr/src/nuxt-app/plugins/i18n.js";
import primevue_TdXjRgL1MA from "/usr/src/nuxt-app/plugins/primevue.js";
import scroll_to_top_client_CeCGj4sUYe from "/usr/src/nuxt-app/plugins/scroll-to-top.client.js";
import tracking_client_fEUopUxxSj from "/usr/src/nuxt-app/plugins/tracking.client.js";
export default [
  plugin_vue3_A0OWXRrUgq,
  components_plugin_KR1HBZs4kY,
  vueuse_head_plugin_D7WGfuP1A0,
  router_Pg0DINazwm,
  prefetch_client_3cwHvxIDEX,
  fontawesome_klhsrycjcK,
  i18n_sVHQBgnb3t,
  primevue_TdXjRgL1MA,
  scroll_to_top_client_CeCGj4sUYe,
  tracking_client_fEUopUxxSj
]